<div class="reminder">
    <div class="remind">
      <div class="mlabel">Reminder</div>
      <mat-slide-toggle color="primary"></mat-slide-toggle>
    </div>

    <div class="doubleBlock">
      <div class="blockHold">
        <div class="tname">
          <mat-form-field>
            <mat-label>Send Through</mat-label>
            <mat-select value="">
              <mat-option value="">Email</mat-option>
              <mat-option value="">SMS</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="blockHold">
        <div class="tname">
          <mat-form-field>
            <mat-label>Before</mat-label>
            <mat-select value="">
              <mat-option value="">30 min</mat-option>
              <mat-option value="">60 min</mat-option>
              <mat-option value="">1 hour</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

    </div>

    <div class="extrnalTask">
      <mat-checkbox color="primary">Custom</mat-checkbox>
    </div>

    <div class="actionBtnHolder">
      <button
        mat-flat-button
        class="cancel"
        (click)="close()"
      >
        Close
      </button>
      <button
        mat-flat-button
        class="calltoaction"
        type="submit"
        color="primary"
      >
        Remind me
      </button>
    </div>


  </div>